// Ikonit piirretään itse yksinkertaisina viivoina, jotta ne toimivat ilman
// verkkoa ja perivät tekstin värin (currentColor).

const base = { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", "stroke-width": 2, "stroke-linecap": "round", "stroke-linejoin": "round", "aria-hidden": "true" };

export const IconMap = () => (
  <svg {...base}><path d="M9 4 3 6v14l6-2 6 2 6-2V4l-6 2-6-2Z" /><path d="M9 4v14M15 6v14" /></svg>
);
export const IconControl = () => (
  <svg {...base}><circle cx="12" cy="12" r="8" /><circle cx="12" cy="12" r="1.6" fill="currentColor" /></svg>
);
export const IconPassport = () => (
  <svg {...base}><rect x="5" y="3" width="14" height="18" rx="2" /><circle cx="12" cy="10" r="3" /><path d="M9 16h6" /></svg>
);
export const IconDiary = () => (
  <svg {...base}><path d="M4 5h16M4 12h16M4 19h10" /></svg>
);
export const IconLocate = () => (
  <svg {...base}><circle cx="12" cy="12" r="4" /><path d="M12 2v3M12 19v3M2 12h3M19 12h3" /></svg>
);
export const IconLegend = () => (
  <svg {...base}><rect x="4" y="4" width="6" height="6" /><circle cx="17" cy="7" r="3" /><path d="M4 17h16" /></svg>
);
export const IconStart = () => (
  <svg {...base}><path d="M5 21V4M5 4h11l-2 4 2 4H5" /></svg>
);
export const IconBack = () => (
  <svg {...base}><path d="m15 18-6-6 6-6" /></svg>
);
export const IconAddTile = () => (
  <svg {...base}><rect x="4" y="4" width="16" height="16" stroke-dasharray="3 2.5" /><path d="M12 9v6M9 12h6" /></svg>
);
export const IconBase = () => (
  <svg {...base}><path d="M3 20h18M5 20V11l7-6 7 6v9" /><path d="M10 20v-5h4v5" /></svg>
);
export const IconLeaderboard = () => (
  <svg {...base}><path d="M3 21V12h6v9M9 21V5h6v16M15 21v-6h6v6M2 21h20" /></svg>
);
export const IconLayers = () => (
  <svg {...base}><path d="m12 3 9 5-9 5-9-5 9-5Z" /><path d="m3 13 9 5 9-5" /></svg>
);
export const IconChevron = () => (
  <svg {...base} style={{ width: 16, height: 16 }}><path d="m6 9 6 6 6-6" /></svg>
);

// Seikkailukortit: rastilippu.
export const IconAdventure = () => (
  <svg {...base}><path d="M6 21V4" /><path d="M6 4h11l-2.5 4L17 12H6" /></svg>
);

